"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = camelCaseObject;
var _camelCase = _interopRequireDefault(require("lodash/camelCase"));
var _mapKeys = _interopRequireDefault(require("lodash/mapKeys"));
var _mapValues = _interopRequireDefault(require("lodash/mapValues"));
var _isPlainObject = _interopRequireDefault(require("lodash/isPlainObject"));
function mapObject(obj, callback) {
  if (Array.isArray(obj)) {
    return obj.map(function (value) {
      return mapObject(value, callback);
    });
  }
  if (!(0, _isPlainObject["default"])(obj)) {
    return obj;
  }
  var mappedObject = (0, _mapKeys["default"])(obj, function (value, key) {
    return callback(key);
  });
  return (0, _mapValues["default"])(mappedObject, function (value) {
    return mapObject(value, callback);
  });
}
function camelCaseObject(obj) {
  if (!(0, _isPlainObject["default"])(obj)) {
    return obj;
  }
  return mapObject(obj, _camelCase["default"]);
}
//# sourceMappingURL=camelCaseObject.js.map